import styled from "@emotion/styled";

export const PrimaryText = styled("span")(
    ({ theme, $primary, $grey }: any) => `
    font-weight: 500;
    font-size: 1em;
    display: block;
    color: ${theme.palette.primary.main};
`
);

export const Separator = styled("div")(
    ({ theme }: any) => `
    width: 100%;
    border-top: 1px solid ${theme.palette.grey2.light};
    `
);
